import { ApiService } from 'services';

/* eslint-disable-next-line */
export function redirectToLogout() {
  const url = ApiService.getLogoutUrl();

  if (url) {
    window.location = url;
  }
}
